import React from 'react';
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Cookies } from "react-cookie-consent";

import {
    start_loader,
} from "../../actions";
import { toast } from "react-toastify";
import * as constand from "../../constant";
import ReactPlayer from 'react-player';
import CommonForm from './CommonForm';
import { commonService } from '../../_services';

class AsthmaLandingPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            videoUrl: 'https://vimeo.com/427103500',
        }
    }
    render() {
        let condition = commonService.replaceChar(this.props.params.condition, true);
        Cookies.set('condition', condition);

        return (
            <React.Fragment>
                <div className="kd_landing_page cancer_landing_page">
                    <section className="bg-contrast1">
                        <div class="container-fluid w-80 fullwidth">
                            <div class="row">
                                <div class="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-12 text-center welcome-container mx-auto">
                                    <div className="welcome-kidney font-bold white-txt">Welcome to Kidney Beam Asthma Kids</div>

                                    <div class="helping-physiotherap white-txt font-qbold col-12 mx-auto">Helping young people living with asthma to feel good through movement, education and wellbeing support.</div>
                                    <Link class="btn bluebtn m-t-50 font-18  w-45 p-t-10 p-b-10" to={'/register'}>Get Started</Link>
                                </div>
                                <div class="col-xl-3 col-lg-2 col-md-3 col-sm-3 d-sm-block header-img">
                                    <img class="img-fluid" src={constand.WEB_IMAGES + "Sun-landing.png"} />
                                </div>
                            </div>
                        </div>
                    </section>
                    <section>
                        <div class="container-fluid fullwidth">
                            <div className="col-lg-8 mx-auto">
                                <div class="row">
                                    <div className="w-30 col-lg-6 col-md-12 text-center"><p className="font-medium proud-text text-abbey ">Proudly in partnership with…</p></div>
                                    <div className="col-lg-6 col-md-12 align-self-center">
                                        <img src={constand.WEB_IMAGES + "logos/RBHH-logo.jpg"} />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="bg-contrast2">
                        <div class="container-fluid w-80 fullwidth">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="partner-title-black" id="clinicians">What we offer</div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="icon-desc m-t-20 font-qmedium offer-text" >
                                    Here at Kidney Beam we aim to create a space that will support and inspire you. We develop sessions designed to improve your physical and emotional wellbeing. Our instructors are specialists working with young people who have asthma so you can be confident they'll understand your needs.
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 icon-img mx-auto">
                                    <div class="icon-img"><img src={constand.WEB_IMAGES + "On-demand.png"} /></div>
                                    <div class="icon-title"><span>Progressive </span><span id="content2">Programmes</span></div>
                                    <Link class="btn btn-purple m-t-30 p-t-10 p-b-10" to={'programs/asthma kids'}>Explore</Link>
                                    <div class="icon-desc m-t-20 font-qmedium">Programmes are curated for people with specific treatment needs, disease severity, or to help you explore different types of exercise for physical and emotional wellbeing.</div>
                                </div>
                                <div class="col-lg-4 col-md-4 icon-img mx-auto">
                                    <div class="icon-img w-50 mx-auto"><img src={constand.WEB_IMAGES + "Asset-60.png"} /></div>
                                    <div class="icon-title">Live and On-demand classes</div>
                                    <Link class="btn btn-purple m-t-30 p-t-10 p-b-10" to={'liveClasses/asthama kids'}>Explore</Link>
                                    <div class="icon-desc m-t-20 font-qmedium">Live group classes, or pre-recorded on demand sessions in exercise, education and wellbeing, led by specialists to improve physical and emotional health.</div>
                                </div>
                                
                                
                            </div>
                        </div>
                    </section>
                    <section class="">
                        <div class="container-fluid w-80 p-b-20 fullwidth">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="partner-title-black" id="clinicians">How do I get started?</div>
                                </div>
                                <div class="section-content font-qmedium">
                                We are currently piloting Kidney Beam Asthma Kids with a specific research group. If this is you and you have a research code please click below to sign up.
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-4 offset-lg-4 col-8 mx-auto text-center">
                                    <Link class="btn bluebtn w-100 m-t-30 p-t-10 p-b-10" to={'register'}>Sign up</Link>
                                </div>

                            </div>
                        </div>
                    </section>

                    <section className="section-3 bg-white p-t-30 p-b-30">
                        <div className="container-fluid m-auto w-75 fullwidth">
                            <div className="row position-relative">
                                <div className="col-12 d-flex align-items-center  col-md-9 col-lg-8 text-left  p-b-30">
                                    <div className="card cardnew border-0 align-section">
                                        <div className="card-block">
                                            <h4 className="clearfix text-abbey take-tour font-medium float-left w-100">Important safety information</h4>
                                        </div>
                                        <div className="m-t-30">
                                            <p className="before-start text-abbey ">
                                            Before you start exercising online we ask you to read these top recommendations to ensure that you keep safe and feel your best during and after you get physically active. 
                                    </p>
                                        </div>
                                        <div className="readnow">
                                            <Link class="btn btn-darkblue col-md-5 col-10 p-t-10 p-b-10 w-80" to={'blogs/safety-information-for-kids-with-asthma-on-beam'}>Read Now</Link></div>
                                    </div>
                                </div>
                                <div className="col-3 col-md-3 col-lg-4 text-center align-self-center glass-image">
                                    <figure><img src={constand.WEB_IMAGES + "landing/Beam_Character_glass.png"} className="important-asset w-50" alt="" /></figure>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="bg-contrast3 section-2 p-t-80">
                        <div className="container-fluid mx-auto w-75 fullwidth">
                            <div className="row">
                                <div className="col-12 col-md-4 col-lg-4 text-left p-b-30 video-player-order">
                                    <ReactPlayer url={this.state.videoUrl} controls={false} width='100%' height='100%' style={{
                                        width: '100%',
                                        height: '100%'
                                    }} />

                                    {/* <figure className="text-left"><img src="/images/blog_img_044.png" className="img-fluid" alt="" /></figure> */}
                                </div>

                                <div className="col-12 col-md-8 col-lg-8 pl-5 align-section align-items-center">
                                    <div className="">
                                        <h4 className="m-b-20 text-abbey take-tour font-semibold card-block">Take a tour</h4>

                                        <p className="text-abbey before-start">
                                        Kidney Beam co-founder, Pamela Scarborough talks you through the ins and outs of the website and all you need to know to get started in this short video.
                                </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section class="">
                        <div class="container-fluid w-80 p-b-20 fullwidth">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="partner-title-black" id="clinicians">For clinicians, exercise specialists, charities and partners</div>
                                </div>
                                <div class="section-content font-qmedium">
                                Kidney Beam has been developed in collaboration with asthma clinicians and charities. We strive to be a platform that you can trust and rely on and which will support you to care for your community. To understand more about kidney Beam or to express an interest in working with us in future please click the button below and complete our contact form.
				                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-4 offset-lg-4 col-8 mx-auto text-center">
                                    <Link class="btn bluebtn w-100 m-t-30 m-b-30 p-t-10 p-b-10" to={'#contact-form'}>Contact us</Link>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="section-content font-qmedium">
                                If you are interested in becoming an instructor on Kidney Beam please  <a href="https://forms.gle/Md6g5y7ufEetYvfM7" className="purplefont"><u>fill out this form.</u></a> We look forward to hearing from you!
				                </div>
                            </div>
                        </div>
                    </section>


                    <section class="bg-contrast4">
                        <div class="container-fluid w-80 fullwidth" id="contact-form">
                            <div class="row">
                                <div class="col-lg-12 text-center">
                                    <p class="font-medium take-tour text-abbey">Get in touch</p>
                                    <p class="font-qmedium text-abbey m-t-40 section-content">If you need help signing up, have any questions or want to get in touch for any other reason then please complete the form below. Not a fan of forms? Drop us a note to hello@kidneybeam.com and someone from the Kidney Beam Team will get back to you.</p>
                                    <div class="section-content text-left">
                                        <div className="col-lg-8 col-md-12 ml-auto mr-auto">
                                            <CommonForm location={this.props.location} from="asthma" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </React.Fragment>
        )
    };
}

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = {
    start_loader
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AsthmaLandingPage);
